import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { familia } from 'src/app/shared/object/familia.model';
import { formato } from 'src/app/shared/object/formato.model';
import { impuesto } from 'src/app/shared/object/impuesto.model';
import { lista_precio_detalle } from 'src/app/shared/object/lista_precio_detalle.model';
import { producto } from 'src/app/shared/object/producto.model';
import { producto_formatoJoin } from 'src/app/shared/object/producto_formatoJoin.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { unidad_medida } from 'src/app/shared/object/unidad_medida.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ToastService } from 'ng-uikit-pro-standard';
import { ProductosModalResumenComponent } from './modal-resumen/modal-resumen.component';
import { ProductoModalDatosComercialesComponent } from './modal-datos-comerciales/modal-datos-comerciales.component';
import { ProductoModalSeleccionarImpuestoComponent } from './modal-seleccionar-impuesto/modal-seleccionar-impuesto.component';
import { ProductoModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { ProductoModalAddComponent } from './modal-add/modal-add.component';
import { ProductoModalStockComponent } from './modal-stock/modal-stock.component';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ProductoService } from 'src/app/services/producto.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { Subscription } from 'apollo-client/util/Observable';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ProductosComponent implements OnInit {
  // Modales
  @ViewChild(ProductoModalAddComponent, { static: true }) modalAdd: ProductoModalAddComponent;
  @ViewChild(ProductoModalAddEditComponent, { static: true }) modalAddEdit: ProductoModalAddEditComponent;
  @ViewChild(ProductosModalResumenComponent, { static: true }) modalResumen: ProductosModalResumenComponent;
  @ViewChild(ProductoModalDatosComercialesComponent, { static: true }) modalDatosComerciales: ProductoModalDatosComercialesComponent;
  @ViewChild(ProductoModalSeleccionarImpuestoComponent, { static: true }) modalSeleccionarImpuestos: ProductoModalSeleccionarImpuestoComponent;
  @ViewChild(ProductoModalStockComponent, { static: true }) modalStockProducto: ProductoModalStockComponent;

  private client: GraphQLClient = null;

  formulario: FormGroup;
  formDatosComerciales: FormGroup;
  @ViewChild('agregarProducto', { static: true }) agregarModalDtoProducto: ModalDirective;
  @ViewChild('editarProducto', { static: true }) editarModalDtoProducto: ModalDirective;
  public codgo_modulo: number = 2;
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());
  public sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

  public busquedaEstado;
  public rut_empresa: number;

  filtersDisabled: boolean = false;
  paginationContext: PaginationContext = new PaginationContext();

  public estado: boolean;
  public sku_producto: string;
  public exento_iva_estado: boolean;
  public afecto_regla_comerciales_estado: boolean;
  public neto_1: number;
  public neto_2: number;
  public neto_3: number;
  public neto_4: number;
  public neto_5: number;
  public margen_1: number;
  public margen_2: number;
  public margen_3: number;
  public margen_4: number;
  public margen_5: number;

  public codigo_impuesto: number = 0;

  public codigo_formato_top: string = '';

  public codigo_producto: number = 0;

  listaImpuesto: impuesto[];

  listaProducto: producto[];

  listaListaPrecioDetalle2: lista_precio_detalle[];

  listaProductoFormatoAgregar: producto_formatoJoin[];
  listaProductoFormatoEditar: producto_formatoJoin[];
  listaProductoFormatoResumen: producto_formatoJoin[];

  listaRubro: rubro[];

  listaFormato: formato[];

  listaFamilia: familia[];
  listaFamiliaRubro: familia[];

  listaUnidad_Medida: unidad_medida[];

  public filtroSku: string;
  public filtroDescipcion: string;
  public filtrofamilia: Array<any> = [];
  public filtroActivo: boolean = true;

  optionsFamilia: Array<any> = [];

  optionsFormato: Array<any> = [];

  optionsFormatoProducto: Array<any> = [];

  optionsRubro: Array<any> = [];

  optionsUnidadMedida: Array<any> = [];

  public checkboxModel: any = { left: false };

  public impuestoAdicPro: number;
  public parametro_iva: number;

  public iva1: number;
  public impAdicional1: number;
  public preciofinal1: number;

  public iva2: number;
  public impAdicional2: number;
  public preciofinal2: number;

  public iva3: number;
  public impAdicional3: number;
  public preciofinal3: number;

  public iva4: number;
  public impAdicional4: number;
  public preciofinal4: number;

  public iva5: number;
  public impAdicional5: number;
  public preciofinal5: number;

  // Utils
  private log: any;

  // NOTE: VARIABLES PARA SCROLL
  showButton = false;
  scrollHeight = 100;
  private PageNum = 1;
  showButtonDown: boolean;

  listOfProducts: any;
  currentPayLoad: any;
  totalRegistrosPos: any;
  totalPagPos: any;
  PagPosActual: any;
  notEmptyPost = true;
  notscrolly = true;
  subscription: Subscription;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    client: GraphQLClient,
    private clog: ConsoleService,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private toastrService: ToastService,
    private productoService: ProductoService,
    private messageRendererService: MessageRendererService
  ) {
    this.onScrollTop();
    this.log = this.clog.log('MANTENEDOR-PRODUCTOS');
    this.client = client;
    this.busquedaEstado = 1;
  }
  showInfo() {
    const options = { opacity: 1 };
    this.toastrService.info('Info message', 'Toastr info!', options);
  }

  showSuccess() {
    const options = { opacity: 1 };
    this.toastrService.success('Registro grabado!', 'Informacion!', options);
  }
  //public radioModel: string = "porcentajeLeft";

  ngOnInit() {
    this.onScrollTop();
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();

    this.paginationContext.RecordsByPage = 20;

    this.obtenerElemento();
    // this.buscar(1)
  }

  @HostListener('window:scroll')
  onWindowsScroll(): void {
    const yOffSet = window.pageYOffset;
    const scrollTop = this.document.documentElement.scrollTop;

    // NOTE: Mostrar u ocultar botones de ayuda SCROLL
    if (this.listOfProducts != null) {
      this.showButton = (yOffSet || scrollTop) > this.scrollHeight;
      this.showButtonDown = (yOffSet || scrollTop) >= 0;
    }
  }

  handleCheckTodos({ checked }) {
    this.filtersDisabled = checked;
  }

  showModalAgregarDtoProducto() {
    this.modalAdd.showNew();
  }

  loadAndShowProducto(pro: producto) {
    this.modalAddEdit.showEdit(pro);
  }

  obtenerElemento() {
    let self = this;
    this.client.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            rubro {
              obtenerRubros(empresa_rut: $empresa_rut) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                    empresa_rut
                  }
                }
              }
            }
            familia {
              obtenerFamilias(empresa_rut: $empresa_rut) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    empresa_rut
                    rubro_codigo
                  }
                }
              }
            }
            formato {
              obtenerFormatos(empresa_rut: $empresa_rut) {
                respuesta {
                  registros {
                    empresa_rut
                    codigo
                    nombre
                    cantidad
                    formato_padre
                    fecha_registro
                    rut_usuario_creacion
                    rut_usuario_modificacion
                    es_compra
                    es_venta
                  }
                }
              }
            }
            unidad_medida {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
            impuesto {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    nombre
                    descripcion
                    es_adicional
                    es_retenido
                    es_porcentaje
                    valor
                    factor
                    fecha_registro
                  }
                }
              }
            }
            parametro_empresa {
              obtenerIVA(entidad: { empresa_rut: $empresa_rut }) {
                respuesta {
                  valor_numerico
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: this.rut_empresa,
        },
        fetchPolicy: 'network-only',
      },
      function (respuesta) {
        self.listaRubro = respuesta.data.rubro.obtenerRubros.respuesta.registros;
        self.optionsRubro = [];
        var sel: any;
        self.listaRubro.forEach((element) => {
          sel = { value: element.codigo, label: element.descripcion };
          self.optionsRubro.push(sel);
        });

        self.listaFamilia = respuesta.data.familia.obtenerFamilias.respuesta.registros;
        self.optionsFamilia = [];
        var sel: any;
        self.listaFamilia.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsFamilia.push(sel);
        });

        self.listaFormato = respuesta.data.formato.obtenerFormatos.respuesta.registros;
        self.optionsFormato = [];
        var sel: any;
        self.listaFormato.forEach((element) => {
          if (element.es_venta == true) {
            sel = { value: element.codigo, label: element.nombre };
            self.optionsFormato.push(sel);
          }
        });

        self.listaUnidad_Medida = respuesta.data.unidad_medida.obtenerTodos.respuesta.registros;
        self.optionsUnidadMedida = [];
        var sel: any;
        self.listaUnidad_Medida.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsUnidadMedida.push(sel);
        });
        // self.listaImpuesto = respuesta.data.impuesto.obtenerTodos.respuesta.registros;

        self.parametro_iva = respuesta.data.parametro_empresa.obtenerIVA.respuesta.valor_numerico;
      }
    );
  }

  //* LA BARRA DEL SCROLL QUEDA AL INICIO AL INGRESAR A LA VISTA - SCROLL CON BOTON SUBIR
  onScrollTop(): void {
    this.document.documentElement.scrollTop = 0;
  }

  //* SE PUEDE REALIZAR UN SCROLL A TRAVES DEL BOTON BAJAR
  onScrollAbajo(): void {
    this.document.documentElement.scrollBy(0, 1000);
  }

  //* AL REALIZAR EL SCROLL HACIA ABAJO SE AGREGAN LOS SIGUIENTES 100 DATOS DE LA PAGINA SGTE
  onScrollDown(e): void {
    const inputParams = _.cloneDeep(this.currentPayLoad);

    if (inputParams != undefined || inputParams != null) {
      delete inputParams.paginaActual;
      this.PageNum += 1;
      inputParams.paginaActual = this.PageNum;

      this.spinner.show();

      if (this.notscrolly && this.notEmptyPost) {
        this.productoService.GetProductFiltro(inputParams);
        this.productoService.queryProductos.subscribe((data: any[]) => {
          console.log(data[0].obtenerSegunFiltroProductosModulo.respuesta);
          this.PagPosActual = data[0].obtenerSegunFiltroProductosModulo.respuesta.paginaActual;
          this.totalPagPos = data[0].obtenerSegunFiltroProductosModulo.respuesta.totalPaginas;
          this.totalRegistrosPos = data[0].obtenerSegunFiltroProductosModulo.respuesta.totalRegistros;
          this.listOfProducts.push(...data[0].obtenerSegunFiltroProductosModulo.respuesta.registros);
          this.spinner.hide();
          self.document.getElementById('spinnerX').style.display = 'block';

          if (data[0].obtenerSegunFiltroProductosModulo.respuesta.paginaActual === data[0].obtenerSegunFiltroProductosModulo.respuesta.totalPaginas) {
            this.notEmptyPost = false;
            self.document.getElementById('spinnerX').style.display = 'none';
          }
          if (data[0].obtenerSegunFiltroProductosModulo.respuesta.cantidadRegistrosPorPagina < 20) {
            self.document.getElementById('spinnerX').style.display = 'none';
            this.PagPosActual = 1;
          }
          this.notscrolly = true;
        });
      }
    }
  }

  showModalImpuestos() {
    this.modalSeleccionarImpuestos.loadAndShow(this.codigo_impuesto);
  }

  showModalStock(pro: producto) {
    this.modalStockProducto.loadAndShow(pro);
  }

  capturaImpuesto(impuesto: number) {
    this.codigo_impuesto = impuesto;
  }

  cambiarEstado(listaProFormato: producto_formatoJoin) {
    if (listaProFormato.activo) {
      listaProFormato.activo = false;
    } else {
      listaProFormato.activo = true;
    }
  }

  buscar(currentPage: number) {
    this.paginationContext.CurrentPage = currentPage;
    const self = this; // this is unused
    this.filtroSku = this.filtroSku === undefined ? '' : this.filtroSku;
    this.filtroDescipcion = this.filtroDescipcion === undefined ? '' : this.filtroDescipcion;
    this.filtrofamilia = this.filtrofamilia === undefined ? [0] : this.filtrofamilia;

    // let busquedaEstado = 0
    this.listOfProducts = [];
    let inputParams = {
      empresa_rut: this.rut_empresa,
      sku: this.filtroSku,
      descripcion: this.filtroDescipcion,
      tipobusqueda_estado: this.busquedaEstado,
      familia: this.filtrofamilia,
      paginaActual: 1,
      cantidadRegistrosPorPagina: 20,
    };

    this.currentPayLoad = _.cloneDeep(inputParams);

    this.spinner.show();
    // tipobusqueda_estado
    // 3: TODOS
    // 1: ACTIVO
    // 2: INACTIVO
    // if (this.filtersDisabled) {
    //   inputParams.tipobusqueda_estado = 3
    //   inputParams.sku = ''
    //   inputParams.descripcion = ''
    //   inputParams.familia = []
    // }
    // else {
    //   inputParams.tipobusqueda_estado = this.busquedaEstado ? 1 : 2
    // }
    this.log('inputParams', JSON.stringify(inputParams));

    // *LLAMAR AL SERVICIO CON SUN FUNCION
    this.productoService.GetProductFiltro(inputParams);
    //SUBSCRIBIRSE A LA QUERY
    this.productoService.queryProductos.subscribe((data: any[]) => {
      console.log(data[0].obtenerSegunFiltroProductosModulo.respuesta.registros.slice(0, 20));
      this.PagPosActual = data[0].obtenerSegunFiltroProductosModulo.respuesta.paginaActual;
      this.totalPagPos = data[0].obtenerSegunFiltroProductosModulo.respuesta.totalPaginas;
      this.totalRegistrosPos = data[0].obtenerSegunFiltroProductosModulo.respuesta.totalRegistros;
      this.listOfProducts = data[0].obtenerSegunFiltroProductosModulo.respuesta.registros.slice(0, 20);
      // console.log(this.listOfProducts);
      this.spinner.hide();
      if (data[0].obtenerSegunFiltroProductosModulo.respuesta.paginaActual === data[0].obtenerSegunFiltroProductosModulo.respuesta.totalPaginas) {
        self.document.getElementById('spinnerX').style.display = 'none';
      }
    });
    this.notscrolly = true;
    this.notEmptyPost = true;

    this.PageNum = 1;
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage);
  }

  renderSearchResults({ registros, paginaActual, totalPaginas, totalRegistros }) {
    this.log('paginaActual, totalPaginas, totalRegistros', paginaActual, totalPaginas, totalRegistros);
    this.paginationContext.RecordsCount = totalRegistros;
    this.paginationContext.CurrentPage = paginaActual;
    this.paginationContext.PagesCount = totalPaginas;
    if (totalPaginas === 0) {
      this.paginationContext.PagesCount = 1;
    }
    this.listaProducto = registros;
  }

  loadAndShowResumen(producto: producto) {
    this.modalResumen.loadAndShow(producto, this.parametro_iva);
  }

  loadAndShowDatosComerciales(producto: producto) {
    this.modalDatosComerciales.loadAndShow(producto, this.parametro_iva);
  }

  onAddedOrEditedProduct() {
    this.buscar(1);
  }
}
